import { FETCH_CATEGORY_EDITOR} from '../../../actions/types'
const INITIAL_STATE = {
    data: [],
}
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_CATEGORY_EDITOR:
            return { ...state, data: action.data }
       default:
            return state;
    }
}